import { DriverStatusState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const driverStatusState: DriverStatusState = {
  // Pagination
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  totalRecordCount: 0,

  // Data source
  sortBy: '-event_time',
  sortField: 'lastContact',
  driverStatuses: [],
  driverStatusStats: null,
  driverViolationDetails: null,

  // Export file data source
  documentType: 'pdf',
  driverStatusesExport: [],

  // API request status
  isRequestPending: false,
  isAccountPropsRequestPending: false,
  isDriverStatusesExportRequestPending: false,

  // Show/Hide Columns Modal — `header` holds i18n keys; translate with t() in UI.
  columns: [
    {
      id: 'alias',
      field: 'alias',
      header: 'DriverStatus.driverId',
      order: 0,
      isVisible: true,
      option: { width: '130px' },
    },
    {
      id: 'name',
      field: 'driverName',
      header: 'DriverStatus.driverName',
      order: 1,
      isVisible: true,
      option: { width: '180px', sortBy: 'name' },
    },
    {
      id: 'vbusConnected',
      field: 'ecuConnection',
      // Icon column in the table; label used in Show/Hide Columns modal.
      header: 'DriverStatus.ecuConnection',
      order: 2,
      isVisible: true,
      option: { width: '60px' },
    },
    {
      id: 'eventType',
      field: 'status',
      header: 'DriverStatus.status',
      order: 3,
      isVisible: true,
      option: { width: '120px', sortBy: 'event-type' },
    },
    {
      id: 'assets',
      field: 'vehicle',
      header: 'DriverStatus.vehicle',
      order: 4,
      isVisible: true,
      option: { width: '180px', sortBy: 'asset.name' },
    },
    {
      id: 'lastContact',
      field: 'lastContact',
      header: 'DriverStatus.lastContact',
      order: 5,
      isVisible: true,
      option: { width: '180px', sortBy: 'event_time' },
    },
    {
      id: 'lastPosition',
      field: 'lastPosition',
      header: 'DriverStatus.lastPosition',
      order: 6,
      isVisible: true,
      option: { width: '220px' },
    },
    {
      id: 'currentRuleset',
      field: 'currentRuleset',
      header: 'DriverStatus.currentRuleSet',
      order: 7,
      isVisible: true,
      option: { width: '180px' },
    },
    {
      id: 'availableBreak',
      field: 'untilBreak',
      header: 'DriverStatus.untilBreak',
      order: 8,
      isVisible: true,
      option: { width: '120px' },
    },
    {
      id: 'driveLeft',
      field: 'driveLeft',
      header: 'DriverStatus.driveLeft',
      order: 9,
      isVisible: true,
      option: { width: '120px', sortBy: 'available_drive' },
    },
    {
      id: 'shiftLeft',
      field: 'shiftLeft',
      header: 'DriverStatus.shiftLeft',
      order: 10,
      isVisible: true,
      option: { width: '120px', sortBy: 'available_shift' },
    },
    {
      id: 'cycleLeft',
      field: 'cycleLeft',
      header: 'DriverStatus.cycleLeft',
      order: 11,
      isVisible: true,
      option: { width: '120px', sortBy: 'available_cycle' },
    },
    {
      id: 'gainTimeAt',
      field: 'gainTimeAt',
      header: 'DriverStatus.gainTimeAt',
      order: 12,
      isVisible: true,
      option: { width: '230px', sortBy: 'gain_time_when' },
    },
    {
      id: 'projectedTime',
      field: 'timeGained',
      header: 'DriverStatus.timeGained',
      order: 13,
      isVisible: true,
      option: { width: '160px', sortBy: 'gain_time_how_much' },
    },
    {
      id: 'gainTimeHowMuchNextDay',
      field: 'timeGainedAtStartOfDay',
      header: 'DriverStatus.timeGainedAtStartOfDay',
      order: 14,
      isVisible: true,
      option: { width: '250px', sortBy: 'gain_time_start' },
    },
    {
      id: 'violationType',
      field: 'nextViolation',
      header: 'DriverStatus.nextViolation',
      order: 15,
      isVisible: true,
      option: { width: '180px' },
    },
    {
      id: 'timeOfNextViolation',
      field: 'timeOfNextViolation',
      header: 'DriverStatus.timeOfNextViolation',
      order: 16,
      isVisible: true,
      option: { width: '220px', sortBy: 'next_violation_timestamp' },
    },
    {
      id: 'uncertifiedLogs',
      field: 'uncertifiedLogs',
      header: 'DriverStatus.uncertifiedLogs',
      order: 17,
      isVisible: true,
      option: { width: '180px', sortBy: 'uncertified_logs' },
    },
    {
      id: 'violationNames',
      field: 'violation',
      header: 'DriverStatus.violation',
      order: 18,
      isVisible: true,
      option: { width: '80px' },
    },
    {
      id: 'pendingEditRequests',
      field: 'pendingEdits',
      header: 'DriverStatus.pendingEdits',
      order: 19,
      isVisible: true,
      option: { width: '120px' },
    },
  ],
  sortedColumns: [],
  portalColumnSettings: [],

  // State for toggling a modal
  isToggleExportFileModal: false,
  isToggleShowHideColumnsModal: false,
  isToggleDrivingViolationsModal: false,

  // Filters
  status: 'true',
  subset: null,
  driver: null,
  terminal: null,
};
